export default "__VITE_ASSET__Cga7mrX___"